import { naturalLessThanFlag, wheelTitlePresentationFlag } from '@/_data/developmentFlags';
import type { NaturalLessThanFlag, WheelTitlePresentationFlag } from '@/_data/developmentFlags';
import type { AuthoredConfig, Config } from '@/adapters/primitive/_contract/config';

export function buildPrimitiveConfig(
    config: AuthoredConfig,
    flags: {
        naturalLessThanFlag?: NaturalLessThanFlag;
        wheelTitlePresentationFlag?: WheelTitlePresentationFlag;
    } = {},
): Config {
    const label = config.base.display.label;
    const comparison = config.natural.display.comparison;
    for (const key of ['wheelTitlePresentationMode', 'wheelTitleFlag']) {
        if (key in label) throw new Error(`Flag-owned config field: base.display.label.${key}`);
    }
    for (const key of ['naturalLessThanPresentationMode', 'presentation']) {
        if (key in comparison) throw new Error(`Flag-owned config field: natural.display.comparison.${key}`);
    }
    return {
        ...config,
        base: { ...config.base, display: { ...config.base.display, label: {
            ...label,
            wheelTitlePresentationMode: flags.wheelTitlePresentationFlag ?? wheelTitlePresentationFlag,
        } } },
        natural: { ...config.natural, display: { ...config.natural.display, comparison: {
            ...comparison,
            naturalLessThanPresentationMode: flags.naturalLessThanFlag ?? naturalLessThanFlag,
        } } },
    };
}
